// src/App.jsx
import {
  BrowserRouter as Router, Routes, Route, useLocation
} from 'react-router-dom';
import { useEffect } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import HomePage from '../Home/homePage';
import Contact from '../Contact/contact';
import Privacy from '../Footer/privacy';
import AboutUs from '../AboutUs/AboutUs';
import News from '../News/News';
import Recruitment from '../Recruitment/Recruitment';
import PricingPage from '../Pricing/PricingPage';
import { AuthProvider } from '../../utils/authContext';
import AdminApp from '../AdminApp/AdminApp';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import LegalMentions from '../Footer/legalMentions';

// Composant pour gérer le défilement lors de la navigation
function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Remonter automatiquement en haut à chaque changement de route
    window.scrollTo(0, 0);

    // Si un hash est présent, après le défilement vers le haut,
    // défiler jusqu'à l'élément spécifié
    if (location.hash) {
      // Petit délai pour s'assurer que le DOM est prêt
      setTimeout(() => {
        const element = document.getElementById(location.hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location.pathname, location.hash]); // Réagir aux changements de chemin ET de hash

  return null;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Routes administratives - AdminApp gère toutes les routes admin, y compris login */}
          <Route path="/admin/*" element={<AdminApp />} />

          {/* Routes publiques du site */}
          <Route
            path="/*"
            element={(
              <div className="public-theme" style={{ minHeight: '100vh' }}>
                <Header />
                <ScrollToTop />
                <main style={{ paddingTop: '80px' }}>
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/mentions-legales" element={<LegalMentions />} />
                    <Route path="/qui-sommes-nous" element={<AboutUs />} />
                    <Route path="/actualites" element={<News />} />
                    <Route path="/recrutement" element={<Recruitment />} />
                    <Route path="/tarifs" element={<PricingPage />} />
                  </Routes>
                </main>
                <Footer />
              </div>
            )}
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
